module.exports = __webpack_public_path__ + "static/media/close.c5ac81cd.svg";